// extracted by mini-css-extract-plugin
export default {"MapSwitcher":"MapSwitcher_MapSwitcher__P3Wse"};